function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7828 0.497594C9.91616 0.176031 8.97879 0 8.00022 0C7.02166 0 6.08429 0.176031 5.21763 0.497594L4.52197 8L5.21763 15.5024C6.08429 15.824 7.02166 16 8.00022 16C8.97879 16 9.91616 15.824 10.7828 15.5024L11.4785 8L10.7828 0.497594Z",
  fill: "#FFDA44"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9996 7.99993C15.9996 4.56025 13.8286 1.62787 10.7822 0.497559V15.5024C13.8286 14.372 15.9996 11.4397 15.9996 7.99993Z",
  fill: "#D80027"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 7.99993C0 11.4397 2.171 14.372 5.21741 15.5024V0.497559C2.171 1.62787 0 4.56025 0 7.99993Z",
  fill: "black"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#0052B4"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 8C2 4.688 4.682 2 7.994 2C11.312 2 14 4.688 14 8C14 11.312 11.312 14 7.994 14C4.682 14 2 11.312 2 8ZM10.3821 5.60005H12.1521C11.5761 4.61005 10.6581 3.84205 9.55409 3.46405C9.91409 4.13005 10.1901 4.85005 10.3821 5.60005ZM8.00027 3.22393C8.49827 3.94393 8.88827 4.74193 9.14627 5.59993H6.85427C7.11227 4.74193 7.50227 3.94393 8.00027 3.22393ZM3.19982 7.99995C3.19982 8.41395 3.25982 8.81595 3.35582 9.19995H5.38382C5.33582 8.80395 5.29982 8.40795 5.29982 7.99995C5.29982 7.59195 5.33582 7.19595 5.38382 6.79995H3.35582C3.25982 7.18395 3.19982 7.58595 3.19982 7.99995ZM3.84841 10.4001H5.61841C5.81041 11.1501 6.08641 11.8701 6.44641 12.5361C5.34241 12.1581 4.42441 11.3961 3.84841 10.4001ZM3.84841 5.60005H5.61841C5.81041 4.85005 6.08641 4.13005 6.44641 3.46405C5.34241 3.84205 4.42441 4.60405 3.84841 5.60005ZM8.00027 12.7761C7.50227 12.0561 7.11227 11.2581 6.85427 10.4001H9.14627C8.88827 11.2581 8.49827 12.0561 8.00027 12.7761ZM6.596 9.19995H9.404C9.458 8.80395 9.5 8.40795 9.5 7.99995C9.5 7.59195 9.458 7.18995 9.404 6.79995H6.596C6.542 7.18995 6.5 7.59195 6.5 7.99995C6.5 8.40795 6.542 8.80395 6.596 9.19995ZM9.55409 12.5361C9.91409 11.8701 10.1901 11.1501 10.3821 10.4001H12.1521C11.5761 11.3901 10.6581 12.1581 9.55409 12.5361ZM10.7 7.99995C10.7 8.40795 10.664 8.80395 10.616 9.19995H12.644C12.74 8.81595 12.8 8.41395 12.8 7.99995C12.8 7.58595 12.74 7.18395 12.644 6.79995H10.616C10.664 7.19595 10.7 7.59195 10.7 7.99995Z",
  fill: "#FCFCFC"
});
const SvgBenefrux = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBenefrux, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/benefrux.a696ee7a.svg";
export { ForwardRef as ReactComponent };